module.exports = __webpack_public_path__ + "/images/cover-ext-share.6b479f9.png";